import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import React from 'react'
import { ListagemGestantePuerperaPreNatalPuerperioModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'
import { RiscoGravidezTag } from 'view/atendimentos/detail/soap/pre-natal/components/RiscoGravidezTag'
import { formatIdadeGestacional } from 'view/atendimentos/detail/soap/pre-natal/util-preNatal'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaInfoSectionProps {
  gestantePuerpera: ListagemGestantePuerperaPreNatalPuerperioModel
  iconColor?: Color
}

export function AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection({
  gestantePuerpera,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaInfoSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='infoCircleFilled' color={iconColor} />
          <Text fontWeight='bold'>Informações da gestação</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Risco gestacional</Text>
          <RiscoGravidezTag isAltoRisco={gestantePuerpera?.altoRiscoGestacional} />
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>IG ecográfica</Text>
          <Text>{formatIdadeGestacional(gestantePuerpera?.idadeGestacionalEcograficaEmDias) ?? '-'}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>IG cronológica</Text>
          <Text>{formatIdadeGestacional(gestantePuerpera?.idadeGestacionalCronologicaEmDias) ?? '-'}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
